import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import ACTLogoDark from "../../assets/images/ACT-logo-no-text-dark.png";
import ACTLogoWhite from "../../assets/images/ACT-logo-no-text-white.png";

interface ActLogoProps {
  /** Rendered height in px; width scales to match. Defaults to 32. */
  height?: number;
}

/**
 * The official ACT logo (same asset as the ACT SI Console): dark lettering
 * in light mode, white lettering in dark mode.
 */
function ActLogo({ height = 32 }: ActLogoProps) {
  const theme = useTheme();

  return (
    <Box
      component="img"
      src={theme.palette.mode === "dark" ? ACTLogoWhite : ACTLogoDark}
      alt="ACT logo"
      sx={{ height, width: "auto", display: "block" }}
    />
  );
}

export default ActLogo;
